import DingtalkAPI from "./base";
import {
    ShareDocParams,
} from "../dtos/notify";

export default class DingtalkNotifyAPI extends DingtalkAPI {

    static shareDocAndNotify(data: ShareDocParams) {
        return this.axios.post(`${this.uri}/share-review/invite-join`,data, {
            params: this.baseQuery()
        })
    }

}
